// extracted by mini-css-extract-plugin
module.exports = {"tag-wrapper":"_2oN8H","more-wrapper":"_3RhsD","heading":"_2vsj2","stories":"_2ez9G","text-result":"gmB3h"};